import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_6 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_7 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  id: "kt_modal_add_event_close",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "input-group input-group-sm mb-3" }
const _hoisted_13 = {
  class: "input-group-text",
  id: "inputGroup-sizing-sm"
}
const _hoisted_14 = ["disabled", "data-kt-indicator"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_18 = {
  key: 0,
  id: "commentError",
  class: "form-text text-danger"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  class: "table align-middle table-row-dashed fs-6 gy-1 table-striped",
  id: "table_accounts_requests"
}
const _hoisted_23 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_24 = { class: "col-7" }
const _hoisted_25 = { class: "col-1" }
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = { class: "col-1" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  class: "text-gray-600"
}
const _hoisted_31 = ["data-kt-indicator", "disabled", "onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]

import { ref, onMounted } from "vue";
import { hideModal, showModal } from "@/core/helpers/dom";
import { CommentType } from "@/core/types/CommentType";
import GlobalService from "../services/TenantGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentView',
  setup(__props, { expose: __expose }) {

const commentsViewModalRef = ref<null | HTMLElement>(null);

const isLoading = ref(true);
const submited = ref(false);

const viewCommentType = ref<CommentType>(0);
const viewCommentId = ref(0);
const viewCommentTitle = ref("");

const comments = ref([]);
const commentContent = ref("");
const commentError = ref("");

const show = (type: CommentType, id, title: string) => {
  comments.value = [];
  viewCommentType.value = type;
  viewCommentId.value = id;
  viewCommentTitle.value = title;
  submited.value = false;
  showModal(commentsViewModalRef.value);
  fetchData(type, id);
};

const fetchData = async () => {
  comments.value = (
    await GlobalService.queryComments({
      type: viewCommentType.value,
      size: 100,
      rowId: viewCommentId.value,
    })
  ).data;
};

const addComment = async () => {
  submited.value = true;
  if (commentContent.value == "") {
    commentError.value = "Content is required!";
    return;
  }
  commentError.value = "";
  let data = await GlobalService.createComment({
    type: viewCommentType.value,
    rowid: viewCommentId.value,
    content: commentContent.value,
  });

  comments.value.unshift(data);
  commentContent.value = "";
  submited.value = false;
};

const deleteComment = async (commentId, index) => {
  submited.value = true;
  await GlobalService.deleteComment(commentId, {
    type: viewCommentType.value,
  });

  comments.value.splice(index, 1);
  submited.value = false;
};

const hide = () => {
  hideModal(commentsViewModalRef.value);
};

onMounted(async () => {
  isLoading.value = true;
  isLoading.value = false;
});

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "commentsViewModalRef",
    ref: commentsViewModalRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      (viewCommentId.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t("title.commentsView")) + " ", 1),
                (
                viewCommentType.value == _unref(CommentType).Deposit ||
                viewCommentType.value == _unref(CommentType).Withdrawal ||
                viewCommentType.value == _unref(CommentType).Transfer
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("type.comment." + viewCommentType.value)) + ": " + _toDisplayString(viewCommentTitle.value), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("type.comment." + viewCommentType.value)) + ": " + _toDisplayString(viewCommentTitle.value) + " - " + _toDisplayString(viewCommentId.value), 1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("fields.comment")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "aria-label": "Sizing example input",
                      "aria-describedby": "inputGroup-sizing-sm",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((commentContent).value = $event))
                    }, null, 512), [
                      [_vModelText, commentContent.value]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      type: "button",
                      id: "button-addon2",
                      disabled: isLoading.value || submited.value,
                      "data-kt-indicator": submited.value ? 'on' : null,
                      onClick: addComment
                    }, [
                      (!submited.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("action.add")) + " " + _toDisplayString(_ctx.$t("fields.comment")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createTextVNode(_toDisplayString(_ctx.$t("title.inProgress")) + " ", 1),
                            _hoisted_17
                          ]))
                    ], 8, _hoisted_14)
                  ]),
                  (commentError.value != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(commentError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("table", _hoisted_22, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_23, [
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("fields.comment")), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("fields.user")), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t("action.action")), 1)
                      ])
                    ]),
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                          _createVNode(_component_LoadingRing)
                        ]))
                      : (!isLoading.value && comments.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_29, [
                            _createVNode(_component_NoDataBox)
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(item.content), 1),
                                _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_TimeShow, {
                                    "date-iso-string": item.createdOn
                                  }, null, 8, ["date-iso-string"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-danger p-1",
                                    "data-kt-indicator": submited.value ? 'on' : null,
                                    disabled: isLoading.value || submited.value,
                                    onClick: ($event: any) => (deleteComment(item.id, index))
                                  }, [
                                    (!submited.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t("action.delete")), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_35))
                                  ], 8, _hoisted_31)
                                ])
                              ]))
                            }), 128))
                          ]))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})